import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "p-text-bold",
  style: {"font-size":"20px"}
}
const _hoisted_2 = {
  autocomplete: "off",
  class: "p-d-flex p-flex-wrap p-jc-around"
}
const _hoisted_3 = { class: "p-fluid p-col-12 p-md-6" }
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { for: "note" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { for: "quantity" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { for: "expiredAt" }
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { for: "alertAt" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-fluid p-col-12 p-md-6" }
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { for: "purchasePrice" }
const _hoisted_16 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_17 = { class: "p-error" }

import { numberSeparators } from "@/graphql/utils/utils";
import { activeActivity } from "@/plugins/i18n";
import PriceInput from "@/components/product/PriceInput.vue";
import { useUpdateStock } from "@/graphql/stock/update.stock";
import { Stock } from "@/graphql/types";
import { useStockPermissions } from "@/hooks/permissions/useStockPermission";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateStock',
  props: {
    modelValue: { type: Boolean },
    stock: {},
    productName: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const { canUpdate } = useStockPermissions();
const { submitUpdate, loading, form, openDialog } = useUpdateStock(() =>
  emit("update:modelValue", false)
);
const disabled = computed(() => !canUpdate || loading.value);

return (_ctx: any,_cache: any) => {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.modelValue,
    breakpoints: { '960px': '95vw' },
    style: { width: '60vw' },
    modal: true,
    "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onShow: _cache[13] || (_cache[13] = ($event: any) => (_unref(openDialog)(_ctx.stock))),
    closable: ""
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("update.title")), 1),
        _createElementVNode("small", null, _toDisplayString(_ctx.productName), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("small", _hoisted_17, _toDisplayString(_ctx.$t("stock.variation")) + " : " + _toDisplayString(_unref(form).quantity.$value - _ctx.stock.quantity), 1),
        _createVNode(_component_Button, {
          label: _ctx.$t('save'),
          icon: "pi pi-save",
          disabled: disabled.value,
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(submitUpdate)())),
          loading: _unref(loading)
        }, null, 8, ["label", "disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            style: {"height":"5px"},
            fill: "var(--surface-ground)",
            animationDuration: ".5s",
            mode: "indeterminate"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("payment.note")), 1),
            _createVNode(_component_Textarea, {
              modelValue: _unref(form).note.$value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).note.$value) = $event)),
              id: "note",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(form).note.$validate())),
              class: _normalizeClass({ 'p-invalid': _unref(form).note.$hasError })
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("product.quantity")), 1),
            _createVNode(_component_InputNumber, {
              modelValue: _unref(form).quantity.$value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).quantity.$value) = $event)),
              locale: _unref(numberSeparators)[_unref(activeActivity).separator],
              "max-fraction-digits": 20,
              "allow-empty": true,
              id: "quantity",
              mode: "decimal",
              class: _normalizeClass({ 'p-invalid': _unref(form).quantity.$hasError })
            }, null, 8, ["modelValue", "locale", "class"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("product.expiredAt")), 1),
            _createVNode(_component_Calendar, {
              modelValue: _unref(form).expiredAt.$value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).expiredAt.$value) = $event)),
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_unref(form).expiredAt.$validate())),
              class: _normalizeClass({ 'p-invalid': _unref(form).expiredAt.$hasError }),
              dateFormat: _ctx.$t('format.calendarDate'),
              placeholder: _ctx.$t('format.calendarDate'),
              "year-navigator": true,
              id: "expiredAt"
            }, null, 8, ["modelValue", "class", "dateFormat", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("product.alertAt")), 1),
            _createVNode(_component_Calendar, {
              modelValue: _unref(form).alertAt.$value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).alertAt.$value) = $event)),
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_unref(form).alertAt.$validate())),
              class: _normalizeClass({ 'p-invalid': _unref(form).alertAt.$hasError }),
              dateFormat: _ctx.$t('format.calendarDate'),
              placeholder: _ctx.$t('format.calendarDate'),
              "year-navigator": true,
              id: "alertAt"
            }, null, 8, ["modelValue", "class", "dateFormat", "placeholder"]),
            (_unref(form).alertAt.$hasError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("stock.dateError")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("stock.purchasePrice")), 1),
            _createVNode(_component_InputNumber, {
              modelValue: _unref(form).purchasePrice.$value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).purchasePrice.$value) = $event)),
              locale: _unref(numberSeparators)[_unref(activeActivity).separator],
              "max-fraction-digits": 20,
              "allow-empty": false,
              min: 0,
              id: "purchasePrice",
              mode: "decimal",
              style: {"width":"100%"}
            }, null, 8, ["modelValue", "locale"])
          ]),
          _createVNode(PriceInput, {
            error: _unref(form).exclTax.$hasError,
            exclTax: _unref(form).exclTax.$value,
            "onUpdate:exclTax": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).exclTax.$value) = $event)),
            inclTax: _unref(form).inclTax.$value,
            "onUpdate:inclTax": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).inclTax.$value) = $event)),
            vat: _unref(form).vat.$value,
            "onUpdate:vat": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).vat.$value) = $event))
          }, null, 8, ["error", "exclTax", "inclTax", "vat"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})